import React, { useContext, useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES } from "helpers/constant";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";
import { eventBookingList } from "Apis/eventBooking";
import { eventAttendanceList } from "Apis/eventAttendance";
import { Box, Button, Chip, Typography } from "@mui/material";
import dayjs from "dayjs";

const EventAttendances = () => {
  const { modules, getModuleAccess, isLoading, setIsLoading, filterLoader, setFilterLoader } =
    useContext(LoginFormContext);

  const [eventBookings, setEventBookings] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const [filterVal, setFilterVal] = useState({
    event_id: "",
    full_name: "",
    email: "",
    mobile_number: "",
    total_pass: "",
    total_amount: "",
    status: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      event_id: filterVal?.event_id,
      // full_name: filterVal?.full_name,
      // email: filterVal?.email,
      // mobile_number: filterVal?.mobile_number,
      // total_pass: filterVal?.total_pass,
      // total_amount: filterVal?.total_amount,
      ticket_id: filterVal?.ticket_id,
      status: filterVal?.status?.value,
    },
  };

  const eventBookingData = async () => {
    let response = await eventAttendanceList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setEventBookings(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
      setIsLoading(false);
    }
  };
  const formatFullName = (member) => {
    if (!member) return "-";
    const { first_name = "", middle_name = "", surname = "" } = member;
    return `${first_name} ${middle_name} ${surname}`.trim();
  };

  useEffect(() => {
    getModuleAccess(MODULES.EVENT_ATTENDANCE);
  }, [modules]);

  useEffect(() => {
    eventBookingData();
  }, [filterVal, defaultFilter]);
  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Member Name",
        accessor: "member_name",
        minWidth: "120px",
        sort: false,
        filterInputType: "",
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Event Name",
        accessor: "event",
        minWidth: "120px",
        filterLabel: "Event Name",
        filterAccessor: "event_id",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <Box> {value?.title ? value?.title : "-"} </Box>,
      },
      {
        Header: "Last In",
        accessor: "last_in",
        minWidth: "120px",
        sort: true,
        Cell: ({ value }) => <Box>{value ? dayjs(value).format("DD MMM YYYY hh:mm A") : "-"}</Box>,
      },
      // {
      //   Header: "Last Out",
      //   accessor: "last_out",
      //   minWidth: "120px",
      //   sort: true,
      //   Cell: ({ value }) => <Box>{value ? dayjs(value).format("DD MMM YYYY hh:mm A") : "-"}</Box>,
      // },
      {
        Header: "Status",
        accessor: "status",
        minWidth: "100px",
        filterLabel: "Status",
        filterAccessor: "status",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "In", value: "1" },
          { label: "Out", value: "0" },
        ],
        Cell: ({ value }) => {
          const status = String(value); // Normalize the value

          const statusMap = {
            1: { label: "In", bg: "#e8f5e8", color: "#155724" },
            0: { label: "Out", bg: "#fff3cd", color: "#856404" },
          };

          const current = statusMap[status] || {
            label: "-",
            bg: "#f8f9fa",
            color: "#495057",
          };

          return (
            <MDBox
              sx={{
                display: "inline-block",
                px: 1.5,
                py: 0.5,
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "bold",
                textTransform: "capitalize",
                backgroundColor: current.bg,
                color: current.color,
              }}
            >
              {current.label}
            </MDBox>
          );
        },
      },
    ],
    rows: eventBookings,
  };

  return (
    !isLoading && (
      <>
        <DashboardLayout>
          <DashboardNavbar />

          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            getDataList={eventBookingData}
            rowCount={rowCount}
            tableTitle="Event Attendance List"
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
        </DashboardLayout>
      </>
    )
  );
};

EventAttendances.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
};

export default EventAttendances;
